export default __webpack_public_path__ + "static/media/screenshot-2.6537e71f.png";